import React from "react";

import { toWeekInt } from "../../../helpers/moment";

const WeekControl = ({
  client,
  activeWeek,
  prevWeek,
  nextWeek,
  title = "",
  setTitle = "false",
  t,
}) => {
  return (
    <div className="dashboard__weekcontrol-container">
      {setTitle == true && <p>{title ? title : t("Schedule")}</p>}
      <div className="d-flex" style={{ flexDirection: "row" }}>
        <div className="dashboard__weekcontrol-nextprev">
          <button className="btn text-white" onClick={() => prevWeek()}>
            <i className="fas fa-chevron-left" />
          </button>
        </div>
        <div className="dashboard__weekcontrol-startend-date">
          <span className="dashboard__weekcontrol-nextprev-item">
            {activeWeek.startDate.format("DD")} -{" "}
            {activeWeek.endDate.format("DD MMMM YYYY")}
          </span>
        </div>
        <div className="dashboard__weekcontrol-nextprev">
          <button className="btn text-white" onClick={() => nextWeek()}>
            <i className="fas fa-chevron-right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekControl;
